import basicConfig from "./modules/basicConfig";
import courseManage from "./modules/courseManage";

import type { AddRouteRecordRaw } from "./index";
const route_config: Array<AddRouteRecordRaw> = [
  {
    name: "home",
    path: "/home",
    meta: {
      icon: "home",
      title: "首页",
      is_meun: true,
      path: "/home"
    },
    component: () => import("@/pages/home/index.vue")
  },
  ...courseManage,
  ...basicConfig
];

export default route_config;
